import React, { Component, ReactNode } from 'react';
import { Modal, Box, Typography, IconButton, Divider } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

interface Props {
  open: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
  maxWidth?: string;
  padding?: string;
}

const webStyle = {
  modalStyle: {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: '30px',
    overflowY: 'auto',
    bgcolor: "#FFFFFF",
    boxShadow: 24,
    borderRadius: '20px',
    width: '455px',
    '@media (max-width: 550px)': {
      width: 'auto',
      padding: '15px',
    }
  },
  closeIcon: {
    p: 0,
    "& svg": {
      fontSize: "24px",
      fill: "#000",
    },
  },
  modalTitleContainer: {
    display: 'flex',
    justifyContent: 'end',
  },
  customScrollbar: {
    "&::-webkit-scrollbar": {
      width: "4px",
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: "20px",
    },
    "&:hover::-webkit-scrollbar-thumb": {
      background: "rgba(100, 100, 100, 0.7)",
    },
    "&:hover::-webkit-scrollbar-thumb:hover": {
      background: "rgba(100, 100, 100, 1)",
    },
  },
};

class DeleteModal extends Component<Props> {
  render() {
    const { open, onClose, children } = this.props;

    return (
      <Modal open={open} onClose={onClose} disableRestoreFocus >
        <Box
          sx={{
            ...webStyle.modalStyle,
            ...webStyle.customScrollbar,

          }}
        >
          <Box sx={{ ...webStyle.modalTitleContainer }}>
            <IconButton onClick={onClose} sx={{ ...webStyle.closeIcon }}>
              <CloseRoundedIcon />
            </IconButton>
          </Box>
          <Box>{children}</Box>
        </Box>
      </Modal>
    );
  }
}

export default DeleteModal;